export function LaserModeFactory() {
    return function LaserMode() {
        this.id = null;
        this.code = null;
        this.name = null;
        this.isRegulated = null;
    };
}
